/**
 * initialTrackingState
 *
 * This needs to implement an array of QueryStringParamConfigInterface
 * as defined by uma-utils.
 *   - https://ultimatemedical.github.io/uma-frontend-utilities/interfaces/querystringparamconfiginterface.html
 *
 * What's defined here represents the initial assumptions about
 * tracking information that can be passed on to to our Lead
 * Servicing Vendors.
 *
 * These are initial assumptions which can and will change at the page
 * level and if overrides are passed via query string.
 *
 */

import { hiddenFormParamEnums } from '../../enums'

export default [
  {
    default: '13462',
    key: hiddenFormParamEnums.keys.SCHOOL_ID,
  },
  {
    default: 'Y',
    key: hiddenFormParamEnums.keys.TCPA_CONSENT,
  },
  {
    excludeIfFalsy: true,
    key: hiddenFormParamEnums.keys.VENDOR_LEAD_ID,
    override: /^vendorleadid$/gi,
  },
  {
    excludeIfFalsy: true,
    key: hiddenFormParamEnums.keys.UTM_ADGROUP,
    override: /utm_adgroup/,
  },
  {
    excludeIfFalsy: true,
    key: hiddenFormParamEnums.keys.UTM_CAMPAIGN,
    override: /utm_campaign/,
  },
  {
    excludeIfFalsy: true,
    key: hiddenFormParamEnums.keys.UTM_SOURCE,
    override: /utm_source/,
  },
  {
    excludeIfFalsy: true,
    key: hiddenFormParamEnums.keys.UTM_TERM,
    override: /utm_term/,
  },
  {
    excludeIfFalsy: true,
    key: hiddenFormParamEnums.keys.UTM_MEDIUM,
    override: /utm_medium/,
  },
  {
    excludeIfFalsy: true,
    key: hiddenFormParamEnums.keys.GCLID,
    override: /gclid/,
  },
  {
    default: 'SR_U_10365',
    key: hiddenFormParamEnums.keys.CID,
    override: /^cid$/gi,
  },
  {
    default: '00000',
    key: hiddenFormParamEnums.keys.POSTAL_CODE_OR_ZIP,
  },
  {
    default: hiddenFormParamEnums.values.LEADSOURCE_INITIAL,
    key: hiddenFormParamEnums.keys.LEADSOURCE,
    override: /^(leadsource|ld_src)$/gi,
  },
  {
    default: '',
    excludeIfFalsy: true,
    key: hiddenFormParamEnums.keys.LEADSOURCE2,
    override: /^ls2$/gi,
  },
  {
    default: 'SEO',
    key: hiddenFormParamEnums.keys.LEADVENDOR,
    override: /^leadvendor$/gi,
  },
  {
    default: 'SEO',
    key: hiddenFormParamEnums.keys.VENDOR,
    override: /^vendor$/gi,
  },
  {
    default: 'UMA',
    key: hiddenFormParamEnums.keys.LEAD_BUYER_ID,
    override: /^leadbuyerid$/gi,
  },
  {
    default: '1',
    key: hiddenFormParamEnums.keys.RELAX_VAL,
  },
  {
    default: 'Unspecified',
    key: hiddenFormParamEnums.keys.ADDRESS1,
  },
  {
    default: 'Unspecified',
    key: hiddenFormParamEnums.keys.CITY,
  },
  {
    default: typeof window !== 'undefined' ? window.location.href : 'undefined',
    key: hiddenFormParamEnums.keys.PATH_LABEL,
  },
]
